import React from "react";
import axios from "axios";
// import "./styles.scss";
import i18n from "../../../i18n";
import imagenLogin from "./../../../resources/fondo-login-xpdconnect.jpg";
import {
  Label,
  Container,
  Col,
  Form,
  Card,
  CardHeader,
  CardBody,
  Button,
  Row,
} from "reactstrap";
import { Services } from "../../../repositories/clients/Services";
import logoEuroPartners from "./../../../resources/ePoint_blanco_color.png";
import { withRouter } from "react-router-dom";
import { Input } from "semantic-ui-react";
import { withNamespaces } from "react-i18next";

import SessionStorage from "../../../services/SessionStorage";
import Authentication from "../../../services/Authentication.js";
import { isMobile, getBrowserInfo } from "../../utils/userAgent";
import { SetNewListGroups } from "../../../state/actions/Header";
import { connect } from "react-redux";

import logo from "./../../../resources/logo-xpdconnect-blanco.svg";

const auth = new Authentication();

const BackgroundHead = {
  backgroundImage: `url(${imagenLogin})`,
  backgroundSize: "cover",
  backgroundPosition: "bottom",
};
/*=============================================
=            Login Component                  =
=============================================*/
function Recover(props) {
  const [redirectlogin, setRedirectlogin] = React.useState({
    login: {
      newcontrasena: "",
      valid: false,
      confirmarcontrasena: "",
      check: false,
      email: "",
    },
  });
  let [Mostrar, setMostrar] = React.useState(false);
  let [MostrarNew, setMostrarNew] = React.useState(false);
  let [exito, setexito] = React.useState(false);
  let [TokenValido, setTokenValido] = React.useState(true);
  let [passValid, setPassValid] = React.useState(true);
  let [lengthPassword, setLengthPassword] = React.useState(false);
  let [upperCasePassword, setUpperCasePassword] = React.useState(false);
  let [specialCharPassword, setSpecialCharPassword] = React.useState(false);
  let [newPassword, setNewPassword] = React.useState("");
  let [confirmPassword, setConfirmPassword] = React.useState("");
  const getAutentication = React.useCallback(() => {
    axios
      .get(
        `${Services.ADMIN.path}admin/recovery?token=${props.match.params.token}`,
        {}
      )
      .then((response) => {
        redirectlogin.login.email = response.data.email;
        setRedirectlogin({ redirectlogin, ...redirectlogin });
        setTokenValido(true);
      })
      .catch((error) => {
        setTokenValido(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.token]);

  React.useEffect(() => {
    getAutentication();
  }, []);

  React.useEffect(() => {
    let validText = newPassword;
    let lengthPassword = false;
    let upperCasePassword = false;
    let specialCharPassword = false;

    if (validText.length > 7 && validText.length < 16) {
      lengthPassword = true;
    }
    if (/[A-Z]/.test(validText) && /[a-z]/.test(validText)) {
      upperCasePassword = true;
    }
    if (/["#$%&]/.test(validText)) {
      specialCharPassword = true;
    }

    setLengthPassword(lengthPassword);
    setUpperCasePassword(upperCasePassword);
    setSpecialCharPassword(specialCharPassword);

    if (newPassword === confirmPassword) {
      if (lengthPassword && upperCasePassword && specialCharPassword) {
        setPassValid(false);
        //document.getElementById("input_correo").className = "input100";
      } else {
        //document.getElementById("input_correo").className = "invalidInput";
        setPassValid(true);
      }
    } else {
      //document.getElementById("input_correo").className = "invalidInput";
      setPassValid(true);
    }
  }, [newPassword]); // <- Dependencia

  React.useEffect(() => {
    let validText = confirmPassword;
    let lengthPassword = false;
    let upperCasePassword = false;
    let specialCharPassword = false;

    if (validText.length > 7 && validText.length < 16) {
      lengthPassword = true;
    }
    if (/[A-Z]/.test(validText) && /[a-z]/.test(validText)) {
      upperCasePassword = true;
    }
    if (/["#$%&]/.test(validText)) {
      specialCharPassword = true;
    }
    setLengthPassword(lengthPassword);
    setUpperCasePassword(upperCasePassword);
    setSpecialCharPassword(specialCharPassword);

    if (newPassword === confirmPassword) {
      if (lengthPassword && upperCasePassword && specialCharPassword) {
        setPassValid(false);
        //document.getElementById("input_correo").className = "input100";
      } else {
        //document.getElementById("input_correo").className = "invalidInput";
        setPassValid(true);
      }
    } else {
      document.getElementById("input_correo").className = "invalidInput";
      setPassValid(true);
    }
  }, [confirmPassword]); // <- Dependencia

  function change(event) {
    if (event.target.name === "newcontrasena") {
      setNewPassword(event.target.value);
    }
    if (event.target.name === "confirmarcontrasena") {
      setConfirmPassword(event.target.value);
    }

    if (
      event.target.name === "confirmarcontrasena" ||
      event.target.name === "newcontrasena"
    ) {
      let value = event.target.value;
      redirectlogin.login[event.target.name] = value;
      setRedirectlogin({ redirectlogin, ...redirectlogin });
    } else {
      let value = event.target.value;

      const emailRegex = new RegExp(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&_-])([A-Za-z\d$@$!%*?&_-]|[^ ]){8,15}$/
      );
      /*if (emailRegex.test(value)) {
        document.getElementById("input_email").className = "input100";
        document.getElementById("123456").setAttribute("hidden", "hidden");
      } else {
        document.getElementById("input_email").className = "invalidInput";
        document.getElementById("123456").removeAttribute("hidden");
      }*/
      redirectlogin.login[event.target.name] = value;
      setRedirectlogin({ redirectlogin, ...redirectlogin });
    }
  }

  async function sendLoginAudit(userId, sessionId) {
    const Origin = (await isMobile()) ? "Mobile" : "Desktop";
    const browserInfo = await getBrowserInfo();

    const userAudit = {
      UsuarioId: userId,
      SessionId: sessionId,
      StartConnection: new Date(),
      Origin,
      Browser: browserInfo.name,
    };

    axios.post(`${Services.AUDIT.path}user-logs/login`, userAudit);

    /*navigator.sendBeacon(
      `${Services.AUDIT.path}user-logs/login`,
      JSON.stringify(userAudit)
    );*/
  }

  function handleLoginId() {
    let data = {
      email: redirectlogin.login.email,
      password: redirectlogin.login.newcontrasena,
    };

    axios
      .put(`${Services.ADMIN.path}admin/changePass`, data)
      .then(async (authResponse) => {
        setexito(true);
        console.log("authResponse", authResponse);

        if (authResponse.data.login) {
          const token = authResponse.data.token;
          const userData = authResponse.data.data?.[0];
          const id = userData.UserId;
          const lang = userData.Code;
          const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          const rolId = authResponse.data.rolId;

          /*if (check) {
            localStorage.setItem("email", email);
            localStorage.setItem("password", password);
          }*/

          const groupsResponse = await axios.get(
            `${Services.ADMIN.path}admin/customerForId/v2/${id}?zona=${timezone}&lang=${lang}`
          );

          const {
            resp: group_list,
            clients,
            NIT: nit,
            Notify: notify,
          } = groupsResponse.data;

          console.log("props", props);
          console.log({
            group_list,
            clients,
            nit,
            notify,
            lang,
          });

          await props.SetNewListGroups({
            group_list,
            clients,
            nit,
            notify,
            lang,
          });

          console.log("props update", props);

          const session = new SessionStorage();
          session.addItem("group_list", JSON.stringify(group_list));
          session.addItem("clients", JSON.stringify(clients));
          session.addItem("nit", JSON.stringify(nit));
          session.addItem("notify", JSON.stringify(notify));
          session.addItem("lang", lang);

          console.log("session", session);

          auth.setAuthentication(
            token,
            authResponse.data.data,
            group_list,
            redirectlogin.login.email
          );

          if (rolId === 8) {
            await props.history.push("/supplier-management");
          } else {
            await props.history.push("/dashboard");
          }

          sendLoginAudit(id, token);
        }
      })
      .catch((error) => {
        setTokenValido(false);
      });
  }
  React.useEffect(() => {
    let navLang = navigator.language || navigator.userLanguage;
    i18n.changeLanguage(navLang.split("-")[0] == "es" ? "MX" : "US");
  }, []);

  return (
    <>
      <div style={BackgroundHead}>
        <div className="login-page ">
          <Container>
            {TokenValido ? (
              <div className="">
                {exito ? (
                  <Col
                    xs={12}
                    md={10}
                    lg={6}
                    className="ml-auto mr-auto mt-auto mb-5"
                  >
                    <center className="pb-5">
                      <img src={logo} alt="now-logo" className="logo-login" />
                      <Col xs={12} md={12} lg={12} className="ml-auto mr-auto">
                        <label style={{ color: "#fff", fontSize: "20px" }}>
                          {props.t("pass_change_successfully")}
                        </label>
                        <Button
                          color="primary"
                          // id="loginGo"
                          className="custom-width-bt"
                          onClick={() => props.history.push("/")}
                        >
                          <strong>{props.t("go_epoint")}</strong>
                        </Button>
                      </Col>
                    </center>
                  </Col>
                ) : (
                  // <Container>
                  //   <Card className="loginContainer">
                  //     <CardBody>
                  //       <label
                  //         style={{
                  //           color: "#fff",
                  //           fontSize: "22px",
                  //           marginBottom: "2em",
                  //         }}
                  //       >
                  //         {props.t("pass_change_successfully")}
                  //       </label>{" "}
                  //       <div className="col-12 divcenter">
                  //         <div className="col-3">
                  //           <Button
                  //             id="loginGo"
                  //             block
                  //             style={{ marginBottom: "1em" }}
                  //             className="login100-form-btn-blue"
                  //             // style={{ fontWeight: 'bold', background: '#FF0000' }}
                  //             // color='danger'
                  //             onClick={() => props.history.push("/")}
                  //           // disabled={loading}
                  //           >
                  //             <strong>{props.t("go_epoint")}</strong>
                  //           </Button>
                  //         </div>
                  //       </div>
                  //     </CardBody>
                  //   </Card>
                  // </Container>
                  <>
                    <Col
                      sm={10}
                      md={11}
                      lg={8}
                      xl={6}
                      className="ml-auto mr-auto mt-auto"
                    >
                      <center>
                        <Col
                          xs={10}
                          md={10}
                          lg={10}
                          className="ml-auto mr-auto"
                        >
                          <img src={logo} alt="now-logo" />
                        </Col>

                        <Form>
                          <Col
                            xs={10}
                            md={10}
                            lg={10}
                            className="ml-auto mr-auto"
                          >
                            <CardBody className="cardForms">
                              {/* Inputs */}
                              <Col xs={11} className="mr-auto ml-auto">
                                <label
                                  style={{
                                    color: "#fff",
                                    fontSize: "20px",
                                    fontWeight: "Bold",
                                    marginBottom: "3rem",
                                  }}
                                >
                                  {props.t("recover_pass")}
                                </label>
                                <div id="is-relative">
                                  <Input
                                    icon="icon-password"
                                    iconPosition="left"
                                    placeholder={props.t("new_pass")}
                                    id="input_correo"
                                    type={MostrarNew ? "text" : "password"}
                                    fluid
                                    value={redirectlogin.login.newcontrasena}
                                    name="newcontrasena"
                                    onChange={change}
                                    className="custom-icon-size"
                                  />
                                  <span
                                    id="icon-eye"
                                    onClick={() => setMostrarNew(!MostrarNew)}
                                  >
                                    <i
                                      className={
                                        MostrarNew
                                          ? "icon-password-see eye-pass"
                                          : "icon-password-unsee eye-pass"
                                      }
                                    />
                                  </span>
                                </div>
                              </Col>
                              <span className="focus-input100"></span>
                              <br />
                              <Col xs={11} className="mr-auto ml-auto">
                                <div id="is-relative">
                                  <Input
                                    icon="icon-password"
                                    iconPosition="left"
                                    placeholder={props.t("confirm_pass")}
                                    id="input_correo"
                                    type={Mostrar ? "text" : "password"}
                                    fluid
                                    value={redirectlogin.login.password}
                                    name="confirmarcontrasena"
                                    onChange={change}
                                    className="custom-icon-size"
                                  />
                                  <span
                                    id="icon-eye"
                                    onClick={() => setMostrar(!Mostrar)}
                                  >
                                    <i
                                      className={
                                        Mostrar
                                          ? "icon-password-see eye-pass"
                                          : "icon-password-unsee eye-pass"
                                      }
                                    />
                                  </span>
                                </div>
                                {/*<Input
                                fluid
                                id="input_correo"
                                // className="input100"
                                type={Mostrar ? "text" : "password"}
                                value={redirectlogin.login.confirmarcontrasena}
                                name="confirmarcontrasena"
                                onChange={change}
                                placeholder={props.t("confirm_pass")}
                              />*/}
                              </Col>
                              <span className="focus-input100"></span>

                              {/* Buttom */}
                              <div className="col-12 divcenter">
                                <div>
                                  <Button
                                    id="se_cumple"
                                    block
                                    style={{
                                      marginBottom: "1em",
                                      marginTop: "3em",
                                    }}
                                    color="primary"
                                    // style={{ fontWeight: 'bold', background: '#FF0000' }}
                                    // color='danger'
                                    onClick={handleLoginId}
                                    disabled={passValid}
                                  >
                                    <strong>{props.t("save_change")}</strong>
                                  </Button>
                                </div>
                              </div>

                              <br />
                              <Col
                                xs={11}
                                className="mr-auto ml-auto textInitial"
                              >
                                <label
                                  style={{ color: "#fff", fontSize: "11px" }}
                                >
                                  {lengthPassword ? (
                                    <i
                                      className={"icon-ok-1"}
                                      style={{ color: "#00c15c" }}
                                    />
                                  ) : (
                                    <i
                                      className={"icon-cancel-1"}
                                      style={{ color: "#FF0000" }}
                                    />
                                  )}
                                  {props.t("rule_digits")}
                                </label>
                                <label
                                  style={{ color: "#fff", fontSize: "11px" }}
                                >
                                  {upperCasePassword ? (
                                    <i
                                      className={"icon-ok-1"}
                                      style={{ color: "#00c15c" }}
                                    />
                                  ) : (
                                    <i
                                      className={"icon-cancel-1"}
                                      style={{ color: "#FF0000" }}
                                    />
                                  )}
                                  {props.t("rule_uppercase")}
                                </label>
                                <label
                                  style={{ color: "#fff", fontSize: "11px" }}
                                >
                                  {specialCharPassword ? (
                                    <i
                                      className={"icon-ok-1"}
                                      style={{ color: "#00c15c" }}
                                    />
                                  ) : (
                                    <i
                                      className={"icon-cancel-1"}
                                      style={{ color: "#FF0000" }}
                                    />
                                  )}
                                  {props.t("rule_special_char")}
                                </label>
                              </Col>
                              <br />
                            </CardBody>
                          </Col>
                        </Form>
                      </center>
                    </Col>
                  </>
                )}
              </div>
            ) : (
              <Col
                xs={12}
                md={10}
                lg={6}
                className="ml-auto mr-auto mt-auto mb-5"
              >
                <center className="pb-5">
                  <img src={logo} alt="now-logo" className="logo-login" />
                  <Col xs={12} md={12} lg={12} className="ml-auto mr-auto">
                    <label style={{ color: "#fff", fontSize: "20px" }}>
                      {props.t("error_token")}
                    </label>
                    <Button
                      color="primary"
                      // id="loginGo"
                      className="custom-width-bt"
                      onClick={() => props.history.push("/")}
                    >
                      <strong>{props.t("go_home")}</strong>
                    </Button>
                  </Col>
                </center>
              </Col>
            )}
          </Container>
        </div>
      </div>
    </>
  );
}

const mapStateToProps = () => ({});
const mapDispatchToProps = (dispatch) => ({
  SetNewListGroups: (new_group_list) =>
    dispatch(SetNewListGroups(new_group_list)),
});

export default withNamespaces()(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(Recover))
);
// export default withRouter(Recover);
//export default withNamespaces()(Recover);
